/**
 * Path segments that must never be treated as dynamic ids for static-export shells.
 * CDN/GCS may surface `index.html` or static section names under `/swap-market/{id}`.
 */
const RESERVED_STATIC_PATH_SEGMENTS = new Set([
  "__",
  "index.html",
  "create",
  "history",
  "setup",
  "my-bids",
  "auction",
]);

/**
 * Extracts a dynamic path segment for static-export shells served via CDN rewrite.
 * Ignores the `__` sentinel HTML generated by `generateStaticParams` and reserved
 * static section names (e.g. swap-market `create` / `index.html`).
 * Query strings and fragments are stripped so accidental full-URL inputs still resolve.
 */
export function staticPathParam(
  pathname: string | null | undefined,
  pattern: RegExp,
): string {
  const pathOnly = (pathname ?? "").split(/[?#]/, 1)[0];
  const match = pathOnly.match(pattern);
  const value = match?.[1]?.trim() ?? "";
  if (!value || RESERVED_STATIC_PATH_SEGMENTS.has(value)) {
    return "";
  }
  return value;
}
